/* dashboard-rediseno (15-oct-2026): EL MEDIDOR DEL PIE DE LA TARJETA.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   "Pie, 44 px fijos": a la izquierda el medidor. Arriba, a la izquierda la etiqueta
   ("Readiness") o un chip de estado y a la derecha el valor; abajo, la barra de 6 px. Si no hay
   barra, su espacio queda vacio (el renglon de la barra se reserva igual: nada brinca).

   `MedidorDePreparacion` es la regla de Readiness del documento: SOLO si hay dato (la entrada
   de `usePreparacionDelPanel`); el texto y el color salen de `lib/preparacionDelPanel.js`
   (el MISMO texto que pinta Analiticas). Sin dato devuelve un hueco vacio del mismo ancho. */
import React from 'react';
import { textoDePreparacion, colorDePreparacion } from '../../lib/preparacionDelPanel';
import { PISTA } from './anatomia';

export function Medidor({ izquierda, valor, pct, color, testid, testidValor, testidBarra }) {
  const ancho = Number.isFinite(pct) ? Math.max(0, Math.min(100, pct)) : null;
  return (
    <div className="flex-1 min-w-0 flex flex-col justify-center gap-1.5" data-testid={testid}>
      <div className="h-[22px] flex items-center justify-between gap-2 min-w-0">
        <div className="min-w-0 flex items-center">{izquierda}</div>
        {valor != null ? (
          <span className="w-9 shrink-0 text-right text-[12px] font-semibold tabular-nums text-[#D4D4D4] whitespace-nowrap" data-testid={testidValor}>{valor}</span>
        ) : null}
      </div>
      {/* #391: el hueco del valor se reserva de una vez ("100%"): cada digito nuevo no empuja nada. */}
      <div className="h-1.5">
        {ancho != null ? (
          <div className={PISTA}>
            <div className="h-full rounded-full transition-[width] duration-500 ease-out"
              style={{ width: `${ancho}%`, backgroundColor: color }} data-testid={testidBarra} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

// La etiqueta "Readiness" / "Preparacion" del documento (firma 7).
export function MedidorDePreparacion({ valor, t, sufijoId }) {
  if (valor === undefined || valor === null || !Number.isFinite(Number(valor))) {
    return <div className="flex-1 min-w-0" aria-hidden="true" />;
  }
  const n = Number(valor);
  return (
    <Medidor
      izquierda={<span className="text-[12px] font-semibold text-[#9A9A9A] truncate">{t('dashboard:panel.preparacion')}</span>}
      valor={textoDePreparacion(n)}
      pct={n}
      color={colorDePreparacion(n)}
      testid={`preparacion-${sufijoId}`}
      testidValor={`preparacion-valor-${sufijoId}`}
      testidBarra={`preparacion-barra-${sufijoId}`}
    />
  );
}
